export const TabbingTypes = {
  SET_TABBING_VALUE: "SET_TABBING_VALUE",
  SET_B2B_VALUE: "SET_B2B_VALUE",
};
